import { PersonalDetailsValues, SiteDetailsValues } from "./newUserFlowState";

/**
 * TEST-ONLY mock values for the new-user flow's steps. Once the QA bypass
 * serial/PIN (`devicePublicRegistrationTestBypass.ts`) are used on the device
 * step, every later step in this flow pre-fills with these values so the
 * whole wizard can be clicked through end-to-end without typing test data by
 * hand. Remove alongside the rest of the QA bypass once it's no longer needed.
 */
export const getQaBypassPersonalDetails = (): Omit<
  PersonalDetailsValues,
  "temperatureScale" | "timeFormat" | "dateFormat"
> => ({
  firstName: "QA",
  lastName: "Tester",
  phone: "+15550123456",
  email: "qa.tester@coolautomation.com",
  password: "Qatest123",
  confirmPassword: "Qatest123"
});

export const QA_BYPASS_CUSTOMER_NAME = "QA Test Customer";

export const getQaBypassSiteDetails = (): SiteDetailsValues => ({
  name: "QA Test Site",
  address: "1 Test Street",
  country: "US",
  city: "Test City",
  postalCode: "12345",
  description: "Auto-filled QA test site",
  timezone: "America/New_York",
  state: "NY"
});
